import React from 'react'
import { Grid } from '@material-ui/core'
import { SecaoGenerica } from 'components'
import { Responsavel } from '../Responsavel'

export const FormCadeiaCustodia = (props) => {
  const {
    values,
    touched,
    errors,
    usuarios,
    onChangeUser,
    onChangeInput,
    onChangeDate,
    onBlur,
  } = props

  return (
    <SecaoGenerica titulo="Cadeia de Custódia" spacing={3}>
      <Grid item xs={12}>
        <Responsavel
          usuarios={usuarios}
          label="RESPONSÁVEL PELA FIXAÇÃO"
          nome="usuFix"
          inputName="fixacaoInput"
          dateName="dataFixacao"
          values={values}
          touched={touched}
          errors={errors}
          onChangeUser={onChangeUser}
          onChangeInput={onChangeInput}
          onChangeDate={onChangeDate}
          onBlur={onBlur}
          extrafilterOptions={true}
        />
      </Grid>
      <Grid item xs={12}>
        <Responsavel
          usuarios={usuarios}
          label="RESPONSÁVEL PELA COLETA"
          nome="usuCol"
          inputName="coletaInput"
          dateName="dataColeta"
          values={values}
          touched={touched}
          errors={errors}
          onChangeUser={onChangeUser}
          onChangeInput={onChangeInput}
          onChangeDate={onChangeDate}
          onBlur={onBlur}
          extrafilterOptions={true}
        />
      </Grid>
      <Grid item xs={12}>
        <Responsavel
          usuarios={usuarios}
          label="RESPONSÁVEL PELO ACONDICIONAMENTO"
          nome="usuAcond"
          inputName="acondicionamentoInput"
          dateName="dataAcondicionamento"
          values={values}
          touched={touched}
          errors={errors}
          onChangeUser={onChangeUser}
          onChangeInput={onChangeInput}
          onChangeDate={onChangeDate}
          onBlur={onBlur}
          extrafilterOptions={true}
        />
      </Grid>
      <Grid item xs={12}>
        <Responsavel
          usuarios={usuarios}
          label="RESPONSÁVEL PELO TRANSPORTE"
          nome="usuTrans"
          inputName="transporteInput"
          dateName="dataTransporte"
          values={values}
          touched={touched}
          errors={errors}
          onChangeUser={onChangeUser}
          onChangeInput={onChangeInput}
          onChangeDate={onChangeDate}
          onBlur={onBlur}
          extrafilterOptions={true}
        />
      </Grid>
    </SecaoGenerica>
  )
}
